import { create } from "zustand";

const TarifsButtonToken = create( (set) => ({
  token: false,	
  setToken: (t) => set({token: t}),
}));

export default TarifsButtonToken;